import styled from 'styled-components';

export const StyledRoleButton = styled.button<{ isButtonSelected?: boolean; $isDisabled: boolean }>`
  align-items: center;
  background: ${({ theme, isButtonSelected, $isDisabled }) => {
    if (isButtonSelected) {
      return theme.colors.background.active;
    }
    if ($isDisabled) {
      return theme.colors.background.lighter;
    }
    return theme.colors.background.light;
  }};
  border: solid 0.1rem
    ${({ theme, isButtonSelected }) =>
      isButtonSelected ? theme.colors.success.main : theme.colors.selectionBox.border};
  border-radius: 0.5rem;
  color: ${({ theme, $isDisabled }) => ($isDisabled ? theme.colors.text.lightest : theme.colors.text.main)};
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  justify-content: space-between;
  line-height: 2rem;
  margin-bottom: 1.2rem;
  padding: 1rem 1.8rem;
  position: relative;
  min-width: 25rem;

  svg {
    height: 1.6rem;
    width: 1.6rem;
    margin-right: 1rem;
    path,
    .fa-primary,
    .fa-secondary {
      fill: ${({ theme, isButtonSelected }) => (isButtonSelected ? theme.colors.success.main : theme.colors.grey[500])};
    }
    &[data-icon='arrow'],
    &[data-icon='lock'] {
      margin-right: 0;
    }
    &[data-icon='lock'] {
      height: 1.2rem;
      width: auto;
      path {
        fill: ${({ theme }) => theme.colors.success.main};
      }
    }
  }
`;
